var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-page"},[_c('v-row',{staticClass:"align-end",attrs:{"dense":""}},[_c('v-col',[_vm._t("content")],2),_c('v-col',[_c('span',[_vm._t("default")],2),(_vm.icon)?_c('v-icon',{attrs:{"size":"80"}},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }